import AuthLayout from "@/layouts/AuthLayout.vue";

import type { RouteRecordRaw } from "vue-router";

const authRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/auth/LoginView.vue"),
    meta: {
      layout: AuthLayout,
      guestOnly: true,
    },
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: () => import("@/views/auth/ForgotPasswordView.vue"),
    meta: {
      layout: AuthLayout,
      guestOnly: true,
    },
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: () => import("@/views/auth/ResetPasswordView.vue"),
    meta: {
      layout: AuthLayout,
      guestOnly: true,
    },
  },
  {
    path: "/confirmation-account",
    name: "confirmationAccount",
    component: () => import("@/views/auth/ConfirmationAccountView.vue"),
    meta: {
      layout: AuthLayout,
      guestOnly: true,
    },
  },
];

export default authRoutes;
